/* =============================================================
   AUZZI PDP v2 — JS
   Defer-loaded; runs once on DOMContentLoaded, then attaches
   handlers. Scoped to .pdp-v2 markup.
   ============================================================= */
(function () {
  'use strict';

  var root = document.querySelector('.pdp-v2');
  if (!root) return;

  /* ─────────────────────────────────────────────────────────────
     §4 MEDIA — hover-zoom + thumb rail + main-image swap + counter
     ───────────────────────────────────────────────────────────── */
  function initMedia() {
    var stage = root.querySelector('[data-pdp-stage]');
    var stageImg = stage ? stage.querySelector('img') : null;
    var thumbs = root.querySelectorAll('[data-pdp-thumb]');
    var counter = root.querySelector('[data-pdp-counter]');
    if (!stage || !stageImg) return;

    var idx = 0;
    var total = thumbs.length || 1;

    function pad(n) { return n < 10 ? '0' + n : '' + n; }
    function updateCounter() {
      if (counter) counter.textContent = pad(idx + 1) + ' / ' + pad(total);
    }
    updateCounter();

    thumbs.forEach(function (t, i) {
      t.addEventListener('click', function () {
        var src = t.getAttribute('data-pdp-full');
        var srcset = t.getAttribute('data-pdp-srcset');
        if (!src) return;
        stageImg.src = src;
        if (srcset) stageImg.srcset = srcset;
        thumbs.forEach(function (x) { x.classList.remove('is-active'); });
        t.classList.add('is-active');
        idx = i;
        updateCounter();
      });
    });

    /* Phase 25.3: hover-zoom DISABLED per owner request.
       Lightbox click-to-zoom (image_zoom:"lightbox" in product.json)
       still works independently — only the on-hover 1.4× scale is killed. */
    if (false /* hover-zoom disabled — was: matchMedia('(hover: hover)…') */) {
      stage.addEventListener('mousemove', function (e) {
        var rect = stage.getBoundingClientRect();
        var x = ((e.clientX - rect.left) / rect.width) * 100;
        var y = ((e.clientY - rect.top) / rect.height) * 100;
        stageImg.style.transformOrigin = x + '% ' + y + '%';
      });
      stage.addEventListener('mouseenter', function () { stage.classList.add('is-zooming'); });
      stage.addEventListener('mouseleave', function () {
        stage.classList.remove('is-zooming');
        stageImg.style.transformOrigin = '';
      });
    }
  }

  /* ─────────────────────────────────────────────────────────────
     §5 BUY BOX — variant picker, quantity, ATC, Shop Pay
     ───────────────────────────────────────────────────────────── */
  function initBuyBox() {
    var box = root.querySelector('[data-pdp-buybox]');
    if (!box) return;

    /* Quantity stepper */
    var qty = box.querySelector('[data-pdp-qty]');
    var dec = box.querySelector('[data-pdp-qty-dec]');
    var inc = box.querySelector('[data-pdp-qty-inc]');
    if (qty && dec && inc) {
      dec.addEventListener('click', function () {
        var n = Math.max(1, (parseInt(qty.value, 10) || 1) - 1);
        qty.value = n;
        qty.dispatchEvent(new Event('change', { bubbles: true }));
      });
      inc.addEventListener('click', function () {
        var n = (parseInt(qty.value, 10) || 1) + 1;
        qty.value = n;
        qty.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }

    /* Variant picker: when a radio changes, find the matching variant from JSON
       and update price, save chip, and variant id */
    var variantsScript = box.querySelector('[data-pdp-variants]');
    var variants = [];
    if (variantsScript) {
      try { variants = JSON.parse(variantsScript.textContent || '[]'); } catch (e) {}
    }
    var radios = box.querySelectorAll('.pdp-variant__radio');
    var hiddenIdInput = box.querySelector('[data-pdp-variant-id]');
    var currentPriceEl = box.querySelector('[data-pdp-current-price]');
    var addBtn = box.querySelector('[data-pdp-add]');
    var addLabel = box.querySelector('[data-pdp-add-label]');
    var ctaStatus = box.querySelector('[id^="pdp-cta-status"]');

    function selectedOptions() {
      var opts = [];
      box.querySelectorAll('fieldset[data-pdp-option-index]').forEach(function (fs) {
        var checked = fs.querySelector('input.pdp-variant__radio:checked');
        opts.push(checked ? checked.value : null);
      });
      return opts;
    }
    function matchVariant() {
      var sel = selectedOptions();
      return variants.find(function (vv) {
        if (!vv || !vv.options) return false;
        for (var i = 0; i < sel.length; i++) {
          if (sel[i] !== null && vv.options[i] !== sel[i]) return false;
        }
        return true;
      });
    }
    function formatMoney(cents) {
      try {
        return new Intl.NumberFormat('en-AU', { style: 'currency', currency: 'AUD' }).format(cents / 100);
      } catch (e) {
        return '$' + (cents / 100).toFixed(2);
      }
    }
    function onVariantChange() {
      var v = matchVariant();
      if (!v) return;
      if (hiddenIdInput) hiddenIdInput.value = v.id;
      if (currentPriceEl) currentPriceEl.textContent = formatMoney(v.price);
      if (addBtn) {
        if (v.available) {
          addBtn.disabled = false;
          if (addLabel) addLabel.textContent = 'Add to cart';
        } else {
          addBtn.disabled = true;
          if (addLabel) addLabel.textContent = 'Sold out';
        }
      }
      /* Update sticky mobile ATC */
      var mob = document.getElementById('pdp-v2-mobile-atc');
      if (mob) {
        var mobPrice = mob.querySelector('.pdp-v2-mobile-atc__current');
        if (mobPrice) mobPrice.textContent = formatMoney(v.price);
      }
    }
    radios.forEach(function (r) { r.addEventListener('change', onVariantChange); });

    /* Mark unavailable variant options */
    function refreshUnavailable() {
      if (!variants.length) return;
      box.querySelectorAll('fieldset[data-pdp-option-index]').forEach(function (fs, idx) {
        fs.querySelectorAll('input.pdp-variant__radio').forEach(function (radio) {
          var testOpts = selectedOptions();
          testOpts[idx] = radio.value;
          var match = variants.find(function (vv) {
            for (var i = 0; i < testOpts.length; i++) {
              if (vv.options[i] !== testOpts[i]) return false;
            }
            return true;
          });
          var label = radio.nextElementSibling;
          if (!label) return;
          if (!match || !match.available) {
            label.classList.add('is-unavailable');
          } else {
            label.classList.remove('is-unavailable');
          }
        });
      });
    }
    refreshUnavailable();
    radios.forEach(function (r) { r.addEventListener('change', refreshUnavailable); });

    /* Add-to-cart — opens the side cart drawer + updates the cart bubble count.
       Falls back to /cart navigation only if the drawer custom element isn't
       on the page (cart_type !== 'drawer' or drawer markup missing). */
    if (addBtn) {
      addBtn.addEventListener('click', function () {
        if (addBtn.disabled) return;
        var id = hiddenIdInput ? hiddenIdInput.value : null;
        var quantity = qty ? Math.max(1, parseInt(qty.value, 10) || 1) : 1;
        if (!id) return;

        addBtn.disabled = true;
        var origLabel = addLabel ? addLabel.textContent : 'Add to cart';
        if (addLabel) addLabel.textContent = 'Adding…';

        var cartDrawer = document.querySelector('cart-drawer');
        var bubbleEl   = document.getElementById('cart-icon-bubble');

        // Ask Shopify to return the rendered cart-drawer and cart-icon-bubble
        // sections so we can swap them in client-side (no full page reload).
        var sectionsList = [];
        if (cartDrawer) sectionsList.push('cart-drawer');
        if (bubbleEl)   sectionsList.push('cart-icon-bubble');

        var body = {
          items: [{ id: parseInt(id, 10), quantity: quantity }]
        };
        if (sectionsList.length) {
          body.sections = sectionsList.join(',');
          body.sections_url = window.location.pathname;
        }

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify(body)
        })
          .then(function (r) {
            if (!r.ok) {
              return r.json().then(function (err) { throw err; });
            }
            return r.json();
          })
          .then(function (data) {
            if (addLabel) addLabel.textContent = 'Added';
            if (ctaStatus) ctaStatus.textContent = 'Item added to cart';

            // Update cart bubble (count badge) — replace whole section node so
            // the number updates instantly even before the drawer animates in.
            if (data && data.sections && data.sections['cart-icon-bubble'] && bubbleEl) {
              try {
                var html = new DOMParser().parseFromString(data.sections['cart-icon-bubble'], 'text/html');
                var newBubble = html.querySelector('#cart-icon-bubble');
                if (newBubble) bubbleEl.innerHTML = newBubble.innerHTML;
              } catch (e) { /* fall back to drawer-level refresh below */ }
            }

            // Slide the drawer in from the right with updated contents.
            if (cartDrawer && data && data.sections && data.sections['cart-drawer']) {
              try {
                cartDrawer.renderContents(data);
              } catch (e) {
                if (typeof cartDrawer.open === 'function') cartDrawer.open();
              }
            } else if (cartDrawer && typeof cartDrawer.open === 'function') {
              cartDrawer.open();
            } else {
              // No drawer on the page — gracefully degrade to /cart.
              window.location.href = '/cart';
              return;
            }

            // Dispatch a custom event so other components (e.g. mini-bubble
            // animations) can react.
            try {
              document.dispatchEvent(new CustomEvent('auzzi:cart:added', { detail: data }));
            } catch (e) { /* no-op */ }

            // Reset the button so customers can immediately add another item.
            setTimeout(function () {
              addBtn.disabled = false;
              if (addLabel) addLabel.textContent = origLabel;
            }, 900);
          })
          .catch(function (err) {
            if (addLabel) addLabel.textContent = origLabel;
            addBtn.disabled = false;
            var msg = (err && err.description) || (err && err.message) || 'Sorry, something went wrong';
            if (ctaStatus) ctaStatus.textContent = msg;
          });
      });
    }
  }

  /* ─────────────────────────────────────────────────────────────
     §5 ETA strip — countdown + postcode calculator
     ───────────────────────────────────────────────────────────── */
  function pad(n) { return n < 10 ? '0' + n : '' + n; }
  function fmtDay(d) {
    return d.toLocaleDateString('en-AU', { weekday: 'short', month: 'short', day: 'numeric' });
  }
  function addBusinessDays(d, n) {
    var r = new Date(d);
    while (n > 0) {
      r.setDate(r.getDate() + 1);
      var dy = r.getDay();
      if (dy !== 0 && dy !== 6) n--;
    }
    return r;
  }
  function nextCutoff() {
    var now = new Date();
    var cutoff = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 17, 0, 0, 0);
    if (now > cutoff || now.getDay() === 0 || now.getDay() === 6) {
      cutoff = new Date(now);
      cutoff.setHours(9, 0, 0, 0);
      do {
        cutoff.setDate(cutoff.getDate() + 1);
      } while (cutoff.getDay() === 0 || cutoff.getDay() === 6);
    }
    return cutoff;
  }
  function initETA() {
    var rangeEl = root.querySelector('[data-pdp-eta-range]');
    var cdEl = root.querySelector('[data-pdp-eta-cd]');
    var etaRow = root.querySelector('[data-pdp-eta-row]');
    if (!rangeEl || !cdEl) return;
    var dispatchBase = nextCutoff();
    /* Default range without postcode — Sydney dispatch, NSW/ACT-equivalent
       baseline so the headline ETA matches the largest local market. */
    var minD = addBusinessDays(dispatchBase, 2);
    var maxD = addBusinessDays(dispatchBase, 7);
    rangeEl.textContent = fmtDay(minD) + ' – ' + fmtDay(maxD);
    function tick() {
      var now = new Date();
      var diff = Math.max(0, Math.floor((dispatchBase - now) / 1000));
      var h = Math.floor(diff / 3600);
      var m = Math.floor((diff % 3600) / 60);
      cdEl.textContent = pad(h) + 'h ' + pad(m) + 'm';
    }
    tick();
    setInterval(tick, 60000);
    /* Phase 13 + 16: ETA row is space-reserved via CSS .pdp-eta__row--pending.
       Once dates + countdown are populated, drop the pending class so opacity
       fades from 0 to 1 — no layout shift because height was always reserved. */
    if (etaRow) {
      etaRow.removeAttribute('hidden');
      etaRow.classList.remove('pdp-eta__row--pending');
    }

    /* Postcode lookup */
    /* Sydney dispatch transit windows — from Sydney NSW to AU state.
       Reviewed transit ranges in business days:
         NSW / ACT : 2-5     VIC : 2-7    QLD : 2-7
         SA        : 3-8     WA  : 5-10   TAS : 4-10
       NT not in spec; keep a defensive estimate. */
    function pcToState(pc) {
      if (pc.length === 3) pc = '0' + pc;
      if (pc.length !== 4) return null;
      var n = parseInt(pc, 10);
      if (isNaN(n)) return null;
      if (n >= 200 && n <= 299) return { state: 'ACT', min: 2, max: 5 };
      if (n >= 800 && n <= 999) return { state: 'NT', min: 6, max: 10 };
      if (n >= 1000 && n <= 2599) return { state: 'NSW', min: 2, max: 5 };
      if (n >= 2600 && n <= 2618) return { state: 'ACT', min: 2, max: 5 };
      if (n >= 2619 && n <= 2899) return { state: 'NSW', min: 2, max: 5 };
      if (n >= 2900 && n <= 2920) return { state: 'ACT', min: 2, max: 5 };
      if (n >= 2921 && n <= 2999) return { state: 'NSW', min: 2, max: 5 };
      if (n >= 3000 && n <= 3999) return { state: 'VIC', min: 2, max: 7 };
      if (n >= 4000 && n <= 4999) return { state: 'QLD', min: 2, max: 7 };
      if (n >= 5000 && n <= 5999) return { state: 'SA',  min: 3, max: 8 };
      if (n >= 6000 && n <= 6999) return { state: 'WA',  min: 5, max: 10 };
      if (n >= 7000 && n <= 7999) return { state: 'TAS', min: 4, max: 10 };
      return null;
    }
    var pcInput = root.querySelector('[data-pdp-pc-input]');
    var pcBtn = root.querySelector('[data-pdp-pc-btn]');
    var pcResult = root.querySelector('[data-pdp-pc-result]');
    if (!pcInput || !pcBtn || !pcResult) return;
    function calc() {
      var input = pcInput.value.trim();
      var info = pcToState(input);
      pcResult.hidden = false;
      if (!info) {
        pcResult.classList.add('is-error');
        pcResult.textContent = 'Please enter a valid 4-digit AU postcode.';
        return;
      }
      pcResult.classList.remove('is-error');
      var base = nextCutoff();
      var min = addBusinessDays(base, info.min);
      var max = addBusinessDays(base, info.max);
      pcResult.innerHTML = '<strong>' + info.state + ':</strong> Estimated delivery ' + fmtDay(min) + ' – ' + fmtDay(max);
    }
    pcBtn.addEventListener('click', calc);
    pcInput.addEventListener('keypress', function (e) {
      if (e.key === 'Enter') { e.preventDefault(); calc(); }
    });
  }

  /* ─────────────────────────────────────────────────────────────
     §8 REVIEWS — filter chip toggle + load more (histogram is now
     server-rendered via Liquid, no JS fill needed)
     ───────────────────────────────────────────────────────────── */
  function initReviews() {
    var filters = root.querySelectorAll('[data-pdp-filter]');
    filters.forEach(function (f) {
      f.addEventListener('click', function () {
        filters.forEach(function (x) { x.classList.remove('is-active'); });
        f.classList.add('is-active');
      });
    });

    var loadMore = root.querySelector('[data-pdp-reviews-loadmore]');
    if (loadMore) {
      loadMore.addEventListener('click', function () {
        loadMore.textContent = 'No more reviews available';
        loadMore.disabled = true;
        loadMore.style.opacity = '0.5';
        loadMore.style.cursor = 'default';
      });
    }
  }

  /* ─────────────────────────────────────────────────────────────
     §7 SPECS fallback — find description, parse <table> first, then
     "Key: Value" lines from the prose. Hide the whole section if no
     rows could be extracted. EXCLUDES .tax-note + .caption-large
     elements which carry the locale-missing string and look like .rte.
     ───────────────────────────────────────────────────────────── */
  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function findProductDescription() {
    var candidates = [
      '.product__description.rte',
      '.product-details__content.rte',
      '.product-details__panel .rte',
      'article.product-details__content',
      '.product-single__description',
      '[data-product-description]',
      'main .rte:not(.tax-note):not(.caption-large)'
    ];
    for (var i = 0; i < candidates.length; i++) {
      var el = document.querySelector(candidates[i]);
      if (el && el.innerText.trim().length > 100) return el;
    }
    /* Last resort: largest .rte on the page that ISN'T the tax-note. */
    var rtes = Array.prototype.slice
      .call(document.querySelectorAll('.rte'))
      .filter(function (el) { return !el.classList.contains('tax-note') && !el.classList.contains('caption-large'); })
      .sort(function (a, b) { return b.innerText.length - a.innerText.length; });
    return rtes[0] || null;
  }
  /* Spec icon mapping — picks an SVG based on label keywords.
     Falls back to a generic info icon. All icons are 24x24, currentColor,
     1.8px stroke (matches auzzi-icon visual weight). */
  function specIconFor(label) {
    var L = (label || '').toLowerCase();
    // Power / battery
    if (/(power|battery|batteries|voltage|watt|amp|charge|charging)/.test(L)) {
      return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect x="2" y="7" width="16" height="10" rx="2"/><path d="M22 11v2"/><path d="M6 10v4M10 10v4"/></svg>';
    }
    // Size / dimensions / controller size
    if (/(size|dimension|width|height|depth|length|mm|cm|metre|meter|footprint|controller size)/.test(L)) {
      return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="3" width="18" height="18" rx="2"/><path d="M3 9h18M9 3v18"/></svg>';
    }
    // Material (door / body / frame / made of)
    if (/(material|made|aluminium|aluminum|steel|stainless|wood|timber|plastic|abs|rubber|silicone|cotton|leather)/.test(L)) {
      return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M3 3h18v18H3z"/><path d="M3 9h18M9 9v12"/></svg>';
    }
    // Weight
    if (/(weight|mass|kg|gram|lb|pound)/.test(L)) {
      return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M6 6h12l-2 14H8z"/><circle cx="12" cy="5" r="2"/></svg>';
    }
    // Colour
    if (/(colour|color|finish)/.test(L)) {
      return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="9"/><circle cx="8.5" cy="9.5" r="1.5" fill="currentColor"/><circle cx="15.5" cy="9.5" r="1.5" fill="currentColor"/><circle cx="12" cy="15" r="1.5" fill="currentColor"/></svg>';
    }
    // Capacity / volume
    if (/(capacity|volume|litre|liter|ml|gallon|cup)/.test(L)) {
      return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M7 3h10l-1 6a4 4 0 0 1-8 0z"/><path d="M9 21h6M12 13v8"/></svg>';
    }
    // Warranty / certification
    if (/(warranty|certif|standard|approval|compliance|safety)/.test(L)) {
      return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M12 3l8 4v5c0 5-3.5 8.5-8 9-4.5-.5-8-4-8-9V7z"/><path d="m9 12 2 2 4-4"/></svg>';
    }
    // Lid / cover / closure
    if (/(lid|cover|top|cap|closure|seal)/.test(L)) {
      return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="9"/><path d="M12 3a9 9 0 0 0 0 18"/></svg>';
    }
    // Wireless / connectivity
    if (/(wireless|wifi|wi-fi|bluetooth|range|signal|frequency|hz)/.test(L)) {
      return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12a10 10 0 0 1 14 0"/><path d="M8.5 15.5a5 5 0 0 1 7 0"/><circle cx="12" cy="19" r="1.5" fill="currentColor"/></svg>';
    }
    // Generic doc icon
    return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M14 2v6h6"/><path d="M4 4v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8l-6-6H6a2 2 0 0 0-2 2z"/></svg>';
  }

  function renderSpecRows(rows) {
    /* Phase 11: populate .pdp-specs__list as <li.pdp-spec-row> items.
       Falls back to legacy .pdp-specs__rows container if the new list
       isn't present (back-compat with any cached markup). */
    var target = document.querySelector('.pdp-specs__list') ||
                 document.querySelector('.pdp-specs__rows');
    var section = document.querySelector('#specs, .pdp-specs');
    if (!target || !section) return;
    var useNewMarkup = target.classList.contains('pdp-specs__list');
    target.innerHTML = rows.map(function (r) {
      if (useNewMarkup) {
        return '<li class="pdp-spec-row">' +
                 '<span class="pdp-spec-row__icon" aria-hidden="true">' + specIconFor(r.key) + '</span>' +
                 '<span class="pdp-spec-row__label">' + escapeHtml(r.key) + '</span>' +
                 '<span class="pdp-spec-row__dots" aria-hidden="true"></span>' +
                 '<span class="pdp-spec-row__value">' + escapeHtml(r.value) + '</span>' +
               '</li>';
      }
      /* Legacy card structure fallback */
      return '<div class="pdp-spec-card">' +
               '<div class="pdp-spec-card__icon" aria-hidden="true">' + specIconFor(r.key) + '</div>' +
               '<div class="pdp-spec-card__body">' +
                 '<div class="pdp-spec-card__label">' + escapeHtml(r.key) + '</div>' +
                 '<div class="pdp-spec-card__value">' + escapeHtml(r.value) + '</div>' +
               '</div>' +
             '</div>';
    }).join('');
    if (!useNewMarkup) target.classList.add('pdp-specs__grid');
    section.style.display = '';
    var placeholder = document.querySelector('.pdp-specs__placeholder');
    if (placeholder) placeholder.remove();
  }
  function initSpecsFallback() {
    var section = document.querySelector('#specs, .pdp-specs');
    /* Phase 12 Fix A: target the new .pdp-specs__list first (Phase 11+),
       fall back to legacy .pdp-specs__rows for any cached older markup. */
    var target = document.querySelector('.pdp-specs__list') ||
                 document.querySelector('.pdp-specs__rows');
    if (!section || !target) return;

    /* If the snippet already populated rows (server-side parse from
       Specifications block OR custom.product_spec metafield), leave alone. */
    if (target.children.length > 0) return;

    var source = findProductDescription();
    if (!source) { section.style.display = 'none'; return; }

    /* 1. Try <table> first */
    var table = source.querySelector('table');
    if (table) {
      var trs = Array.prototype.slice.call(table.querySelectorAll('tr'));
      var tableRows = trs.map(function (tr) {
        return Array.prototype.slice.call(tr.children).map(function (c) { return c.innerText.trim(); });
      }).filter(function (cells) {
        return cells.length >= 2 && cells[0] && cells[1];
      }).map(function (pair) {
        return { key: pair[0], value: pair[1] };
      });
      if (tableRows.length >= 2) { renderSpecRows(tableRows); return; }
    }

    /* 2. Then "Key: Value" lines anywhere in the description prose */
    var lines = source.innerText.split(/\n+/).map(function (l) { return l.trim(); }).filter(Boolean);
    var stopWords = /^(features?|package contents?|delivery|returns?|warranty|shipping|about|description)$/i;
    var rows = [];
    for (var i = 0; i < lines.length; i++) {
      var line = lines[i];
      if (stopWords.test(line)) continue;
      var m = line.match(/^([A-Z][A-Za-z0-9 \-\/&()]{1,40}):\s*(.+)$/);
      if (m) rows.push({ key: m[1].trim(), value: m[2].trim() });
      if (rows.length >= 12) break;
    }
    if (rows.length < 2) { section.style.display = 'none'; return; }
    renderSpecRows(rows.slice(0, 10));
  }

  /* ─────────────────────────────────────────────────────────────
     §10 FBT — hydrate via /recommendations/products.json
     ───────────────────────────────────────────────────────────── */
  function initFBT() {
    var fbt = root.querySelector('[data-current-id]');
    if (!fbt) return;
    var currentId = fbt.getAttribute('data-current-id');
    var currentPrice = parseFloat(fbt.getAttribute('data-current-price')) || 0;
    var currentVariant = fbt.getAttribute('data-current-variant');
    var currentTitle = fbt.getAttribute('data-current-title') || '';
    var currentImg = fbt.getAttribute('data-current-img') || '';

    /* Phase 16 CLS fix: defer fetch + reveal until section enters viewport.
       By then the user has scrolled (= input event), so the reveal shift
       carries hadRecentInput=true and is excluded from CLS scoring per
       the W3C Layout Instability spec. */
    function fetchAndRender() {
      fetch('/recommendations/products.json?product_id=' + currentId + '&intent=related&limit=3')
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (data) {
          var valid = (data && data.products) ? data.products.filter(function(p){
            return p && p.price > 0 && p.variants && p.variants[0];
          }) : [];
          if (valid.length < 2) { fbt.hidden = true; return; }
          render(valid);
          fbt.hidden = false;
        })
        .catch(function () { fbt.hidden = true; });
    }

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            io.disconnect();
            fetchAndRender();
          }
        });
      }, { rootMargin: '300px 0px 300px 0px' });
      io.observe(fbt);
    } else {
      /* Fallback for very old browsers: fire immediately. */
      fetchAndRender();
    }

    function fmt(cents) {
      try {
        return new Intl.NumberFormat('en-AU', { style: 'currency', currency: 'AUD' }).format(cents);
      } catch (e) { return '$' + cents.toFixed(2); }
    }

    function render(products) {
      var rowEl = fbt.querySelector('[data-pdp-fbt-row]');
      var totalEl = fbt.querySelector('[data-pdp-fbt-total]');
      var addBtn = fbt.querySelector('[data-pdp-fbt-add]');
      if (!rowEl || !totalEl || !addBtn) return;

      var bundle = [{
        id: currentId,
        title: currentTitle,
        url: window.location.pathname,
        img: currentImg,
        price: currentPrice,
        variant_id: currentVariant,
        is_current: true
      }];
      products.slice(0, 2).forEach(function (prod) {
        bundle.push({
          id: prod.id,
          title: prod.title,
          url: prod.url,
          img: prod.featured_image ? prod.featured_image.replace(/(\.(jpg|jpeg|png|webp))/, '_200x$1') : '',
          price: prod.price / 100,
          variant_id: prod.variants && prod.variants[0] ? prod.variants[0].id : null,
          is_current: false
        });
      });

      rowEl.innerHTML = '';
      bundle.forEach(function (it, idx) {
        var card = document.createElement('div');
        card.className = 'pdp-fbt__card';
        card.innerHTML =
          '<input type="checkbox" class="pdp-fbt__check" data-id="' + it.id + '" data-variant="' + (it.variant_id || '') + '" data-price="' + it.price + '" ' + (it.is_current ? 'disabled' : '') + ' checked aria-label="Include ' + (it.title || '').replace(/"/g, '&quot;') + '">' +
          '<div class="pdp-fbt__imgwrap"><img src="' + it.img + '" alt="" loading="lazy" width="200" height="200"></div>' +
          '<a class="pdp-fbt__title" href="' + it.url + '">' + it.title + '</a>' +
          '<span class="pdp-fbt__price">' + fmt(it.price) + '</span>';
        rowEl.appendChild(card);
        if (idx < bundle.length - 1) {
          var plus = document.createElement('span');
          plus.className = 'pdp-fbt__plus';
          plus.setAttribute('aria-hidden', 'true');
          plus.textContent = '+';
          rowEl.appendChild(plus);
        }
      });
      fbt.hidden = false;

      function recalc() {
        var total = 0;
        var selected = 0;
        rowEl.querySelectorAll('.pdp-fbt__check').forEach(function (cb) {
          if (cb.checked) {
            total += parseFloat(cb.getAttribute('data-price')) || 0;
            selected++;
          }
        });
        totalEl.textContent = fmt(total);
        addBtn.textContent = 'Add ' + selected + ' to cart';
        addBtn.disabled = selected < 2;
        /* Phase 13: if total ever ticks down to $0, hide the whole section */
        if (total <= 0) { fbt.hidden = true; }
      }
      rowEl.querySelectorAll('.pdp-fbt__check').forEach(function (cb) {
        cb.addEventListener('change', recalc);
      });
      recalc();

      addBtn.addEventListener('click', function () {
        var items = [];
        rowEl.querySelectorAll('.pdp-fbt__check:checked').forEach(function (cb) {
          var vid = cb.getAttribute('data-variant');
          if (vid) items.push({ id: parseInt(vid, 10), quantity: 1 });
        });
        if (!items.length) return;
        addBtn.disabled = true;
        var orig = addBtn.textContent;
        addBtn.textContent = 'Adding…';
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: items })
        })
          .then(function (r) { return r.json(); })
          .then(function () { window.location.href = '/cart'; })
          .catch(function () { addBtn.textContent = orig; addBtn.disabled = false; });
      });
    }
  }

  /* ─────────────────────────────────────────────────────────────
     §11 STICKY MOBILE ATC — show after main CTA scrolls out of view
     ───────────────────────────────────────────────────────────── */
  function initStickyAtc() {
    if (window.matchMedia && window.matchMedia('(min-width: 1024px)').matches) return;
    var primaryAtc = root.querySelector('[data-pdp-add]');
    var mobAtc = document.getElementById('pdp-v2-mobile-atc');
    if (!primaryAtc || !mobAtc) return;
    var mobBtn = mobAtc.querySelector('[data-pdp-mobile-atc]');
    if (mobBtn) {
      mobBtn.addEventListener('click', function () {
        primaryAtc.click();
      });
    }
    /* Phase 20 a11y: use the `inert` attribute instead of aria-hidden.
       aria-hidden leaves the inner button focusable via Tab — screen
       reader users land on a ghost element. `inert` blocks both focus
       and aria tree. */
    if (!('IntersectionObserver' in window)) {
      mobAtc.classList.add('is-visible');
      mobAtc.removeAttribute('inert');
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          mobAtc.classList.remove('is-visible');
          mobAtc.setAttribute('inert', '');
        } else {
          mobAtc.classList.add('is-visible');
          mobAtc.removeAttribute('inert');
        }
      });
    }, { threshold: 0, rootMargin: '0px 0px -50px 0px' });
    io.observe(primaryAtc);
  }

  /* ─────────────────────────────────────────────────────────────
     §12 ANNOUNCEMENT BAR ROTATOR — replaces marquee on PDP
     ───────────────────────────────────────────────────────────── */
  function initRotator() {
    var rot = document.getElementById('pdp-v2-rotator');
    if (!rot) return;
    // Phase 25.1 — dedupe with the standalone rotator IIFE at end of file.
    // Whichever init runs first wins; the other no-ops cleanly.
    if (rot.dataset.rotatorStarted === '1') return;
    var items = rot.querySelectorAll('.pdp-v2-rotator__item');
    if (items.length < 2) {
      if (items[0]) items[0].classList.add('is-visible');
      return;
    }
    var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduced) {
      items[0].classList.add('is-visible');
      rot.dataset.rotatorStarted = '1';
      return;
    }
    rot.dataset.rotatorStarted = '1';
    var i = 0;
    items[0].classList.add('is-visible');
    setInterval(function () {
      items[i].classList.remove('is-visible');
      i = (i + 1) % items.length;
      items[i].classList.add('is-visible');
    }, 5000);
  }

  /* ─────────────────────────────────────────────────────────────
     §B RECENTLY VIEWED — hide entire section when localStorage is empty
     so an empty grid + heading doesn't render. Also runs whenever
     auzzi:recently:viewed is updated by other tabs.
     ───────────────────────────────────────────────────────────── */
  function initRecentlyViewedEmptyState() {
    var STORAGE_KEYS = ['auzzi:recently_viewed', 'auzzi:recently:viewed', 'recently_viewed_products'];
    function hasItems() {
      for (var i = 0; i < STORAGE_KEYS.length; i++) {
        try {
          var raw = localStorage.getItem(STORAGE_KEYS[i]);
          if (!raw) continue;
          var arr = JSON.parse(raw);
          if (Array.isArray(arr) && arr.length > 0) return true;
        } catch (e) {}
      }
      return false;
    }
    var present = hasItems();
    /* Hide every recently-viewed section variant found in DOM */
    var nodes = document.querySelectorAll(
      '[id*="recently_viewed"], .recently-viewed, .recently-viewed-products, .pdp-recently-viewed'
    );
    nodes.forEach(function (el) {
      if (!present) {
        el.hidden = true;
        el.setAttribute('aria-hidden', 'true');
      } else {
        el.hidden = false;
        el.removeAttribute('aria-hidden');
      }
    });
    /* Also: after a beat, recheck (the recently-viewed snippet may hydrate late) */
    setTimeout(function () {
      var nowPresent = hasItems();
      nodes.forEach(function (el) {
        var renderedCards = el.querySelectorAll('.card-wrapper, .card, .grid__item, .product-card');
        if (nowPresent || renderedCards.length > 0) {
          el.hidden = false;
          el.removeAttribute('aria-hidden');
        }
      });
    }, 1500);
  }

  /* ─────────────────────────────────────────────────────────────
     §10b OVERVIEW SCRUB — Phase 12 Fix B
     Description shipped from Shopify often ends with "Specifications:",
     "Package Content", "Delivery excludes" blocks that we now render
     separately (specs panel) or don't need at all. Strip them client-side
     so the Overview reads cleanly. Generic across 60k products.
     ───────────────────────────────────────────────────────────── */
  function initOverviewScrub() {
    var overview = document.querySelector('.pdp-overview__body, .pdp-overview .rte');
    if (!overview) return;
    var KILL_NEEDLES = [
      /specifications?\s*:?/i,
      /package\s*contents?\s*:?/i,
      /package\s*include[ds]?\s*:?/i,
      /what'?s\s*in\s*the\s*box\s*:?/i,
      /delivery\s*exclud/i,
      /shipping\s*exclud/i
    ];
    /* Walk paragraphs / divs at top level + remove if their leading <strong>
       or text matches a kill needle. Also kills following <ul>/<table>/<p>
       siblings up to the next heading (since those are part of the same block). */
    var nodes = Array.prototype.slice.call(overview.children);
    var killing = false;
    nodes.forEach(function (node) {
      var raw = (node.textContent || '').trim();
      var head = raw.slice(0, 60);
      var matched = KILL_NEEDLES.some(function (rx) { return rx.test(head); });
      if (matched) {
        killing = true;
        node.remove();
        return;
      }
      if (killing) {
        /* Stop killing if we hit a new heading or a meaningful prose paragraph
           that doesn't look like a spec/list/note. */
        var tag = node.tagName;
        if (/^H[1-6]$/.test(tag)) { killing = false; return; }
        /* If the node is itself a list/table/p that has no kill needle, also stop. */
        if (raw.length > 80 && !/\bcm\b|\bmm\b|\bkg\b|\b\d+\s*x\s*\d+/i.test(raw)) {
          killing = false;
          return;
        }
        node.remove();
      }
    });
    /* Also kill orphaned <strong> labels that became empty (sometimes Shopify
       wraps "Specifications:" in its own bold-only paragraph). */
    overview.querySelectorAll('p, div').forEach(function (p) {
      var t = (p.textContent || '').trim();
      if (!t) { p.remove(); return; }
      if (/^(specifications?|package\s*contents?|package\s*include[ds]?|delivery\s*exclud|shipping\s*exclud)\s*:?\s*$/i.test(t)) {
        p.remove();
      }
    });
  }

  /* ─────────────────────────────────────────────────────────────
     Bootstrap — wait for first interaction or idle, then run
     ───────────────────────────────────────────────────────────── */
  function runAll() {
    try { initMedia(); } catch (e) { console.warn('[pdp-v2] media:', e); }
    try { initBuyBox(); } catch (e) { console.warn('[pdp-v2] buybox:', e); }
    try { initETA(); } catch (e) { console.warn('[pdp-v2] eta:', e); }
    try { initReviews(); } catch (e) { console.warn('[pdp-v2] reviews:', e); }
    try { initOverviewScrub(); } catch (e) { console.warn('[pdp-v2] overview-scrub:', e); }
    try { initSpecsFallback(); } catch (e) { console.warn('[pdp-v2] specs:', e); }
    try { initFBT(); } catch (e) { console.warn('[pdp-v2] fbt:', e); }
    try { initStickyAtc(); } catch (e) { console.warn('[pdp-v2] sticky:', e); }
    try { initRotator(); } catch (e) { console.warn('[pdp-v2] rotator:', e); }
    try { initRecentlyViewedEmptyState(); } catch (e) { console.warn('[pdp-v2] rv-empty:', e); }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', runAll);
  } else {
    runAll();
  }
})();

/* ===================== Phase 25.1 — rotator init (robust) =====================
   Replaces Phase 25. Notes:
   - The OUTER IIFE above bails at line ~10 when `.pdp-v2` is not in DOM
     (Theme Editor preview, legacy PDP toggle, etc.), which would also skip
     the legacy `initRotator()` call inside `runAll`. This standalone IIFE
     runs unconditionally so the rotator cycles regardless of that gate.
   - Uses `data-rotator-started` to dedupe with the legacy init in §12 so
     we never get two competing setInterval timers on the same root.
   - Adds a brief MutationObserver fallback for cases where the markup is
     injected after DOMContentLoaded (Shopify section re-render, etc.).
   - Wider selector net covers any rename of the rotator markup.
   ============================================================================= */
(function () {
  'use strict';
  var INTERVAL_MS = 3500;
  var SELECTORS = '#pdp-v2-rotator, .pdp-v2-rotator, .pdp-rotator, [data-rotator]';
  var ITEM_SELECTORS = '.pdp-v2-rotator__item, .pdp-rotator__item, [data-rotator-item]';

  function startRotator(root) {
    if (!root || root.dataset.rotatorStarted === '1') return;
    var items = root.querySelectorAll(ITEM_SELECTORS);
    if (items.length < 2) {
      if (items[0]) items[0].classList.add('is-visible');
      return;
    }
    root.dataset.rotatorStarted = '1';
    var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    // Seed: only first visible
    for (var k = 0; k < items.length; k++) {
      items[k].classList.toggle('is-visible', k === 0);
    }
    if (reduced) return; // honor user preference — freeze on first message
    var i = 0;
    setInterval(function () {
      items[i].classList.remove('is-visible');
      i = (i + 1) % items.length;
      items[i].classList.add('is-visible');
    }, INTERVAL_MS);
  }

  function init() {
    var roots = document.querySelectorAll(SELECTORS);
    if (roots.length) {
      roots.forEach(startRotator);
      return;
    }
    // Fallback: rotator not in DOM yet — observe and try again briefly.
    var mo = new MutationObserver(function () {
      var found = document.querySelectorAll(SELECTORS);
      if (found.length > 0) {
        mo.disconnect();
        found.forEach(startRotator);
      }
    });
    mo.observe(document.body, { childList: true, subtree: true });
    setTimeout(function () { mo.disconnect(); }, 10000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();

/* ─────────────────────────────────────────────────────────────────────
   PHASE 16 — Hide empty home-banner (JS fallback for browsers without :has())
   The CSS rule should handle this in modern Chromium/Safari/Firefox, but
   this guard ensures the 420px void collapses even on older WebViews.
   ───────────────────────────────────────────────────────────────────── */
(function () {
  function hideEmptyBanners() {
    document.querySelectorAll('.home-banner').forEach(function (b) {
      var carousel = b.querySelector('.banner.owl-carousel, .banner');
      if (carousel && carousel.children.length === 0) {
        b.style.display = 'none';
      }
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', hideEmptyBanners, { once: true });
  } else {
    hideEmptyBanners();
  }
})();

/* ─────────────────────────────────────────────────────────────────────
   PHASE 16 — Category strip: arrow buttons + edge-fade scroll state
   - Wraps .headder-products-flex in a .cat-strip-wrap container
   - Injects left/right chevron buttons that scroll the strip
   - Toggles can-scroll-left/can-scroll-right classes on the wrapper
     so CSS can fade arrows + edge gradients in/out as the user scrolls
   - Click anywhere except the arrows still passes through to category links
   ───────────────────────────────────────────────────────────────────── */
(function () {
  var SCROLL_AMOUNT = 480; // px per arrow click — roughly 3 tiles

  function makeArrow(direction) {
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'cat-strip-arrow cat-strip-arrow--' + direction;
    btn.setAttribute('aria-label', direction === 'left' ? 'Scroll categories left' : 'Scroll categories right');
    btn.innerHTML = direction === 'left'
      ? '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="m15 18-6-6 6-6"/></svg>'
      : '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="m9 18 6-6-6-6"/></svg>';
    return btn;
  }

  function enhanceStrip(strip) {
    if (!strip || strip.__catStripEnhanced) return;
    strip.__catStripEnhanced = true;

    // Wrap the strip in a positioning container so arrows can be absolute
    var wrap = document.createElement('div');
    wrap.className = 'cat-strip-wrap';
    strip.parentNode.insertBefore(wrap, strip);
    wrap.appendChild(strip);

    var leftBtn  = makeArrow('left');
    var rightBtn = makeArrow('right');
    wrap.appendChild(leftBtn);
    wrap.appendChild(rightBtn);

    function updateScrollState() {
      var maxScroll = strip.scrollWidth - strip.clientWidth;
      var atStart   = strip.scrollLeft <= 4;
      var atEnd     = strip.scrollLeft >= maxScroll - 4;
      var hasOverflow = maxScroll > 4;
      wrap.classList.toggle('can-scroll-left',  hasOverflow && !atStart);
      wrap.classList.toggle('can-scroll-right', hasOverflow && !atEnd);
    }

    leftBtn.addEventListener('click', function () {
      strip.scrollBy({ left: -SCROLL_AMOUNT, behavior: 'smooth' });
    });
    rightBtn.addEventListener('click', function () {
      strip.scrollBy({ left: SCROLL_AMOUNT, behavior: 'smooth' });
    });

    strip.addEventListener('scroll', updateScrollState, { passive: true });
    window.addEventListener('resize', updateScrollState);

    // Run once after layout settles + once more after images load (sizes change)
    updateScrollState();
    setTimeout(updateScrollState, 100);
    window.addEventListener('load', updateScrollState);
  }

  function init() {
    document.querySelectorAll('.headder-products-flex').forEach(enhanceStrip);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
